module.exports = __webpack_public_path__ + "static/media/95.7ba3d390.png";